module.exports = __webpack_public_path__ + "img/icon1.a8e46411.png";